class $a5fd07fa01589658$export$2e2bcd8739ae039 {
    constructor(initialState){
        this.size = 4;
        this.score = 0;
        this.status = "idle";
        this.initialState = initialState || this._createEmptyBoard();
        this.board = initialState ? this._cloneBoard(initialState) : this._createEmptyBoard();
    }
    _cloneBoard(board) {
        return board.map((row)=>[
                ...row
            ]);
    }
    _createEmptyBoard() {
        return Array.from({
            length: this.size
        }, ()=>Array(this.size).fill(0));
    }
    _addRandomTile() {
        const emptyCells = [];
        for(let row = 0; row < this.size; row++){
            for(let col = 0; col < this.size; col++)if (this.board[row][col] === 0) emptyCells.push([
                row,
                col
            ]);
        }
        if (emptyCells.length === 0) return;
        const [r, c] = emptyCells[Math.floor(Math.random() * emptyCells.length)];
        this.board[r][c] = Math.random() < 0.9 ? 2 : 4;
    }
    _moveRowLeft(row) {
        const filtered = row.filter((value)=>value !== 0);
        for(let i = 0; i < filtered.length - 1; i++)if (filtered[i] === filtered[i + 1]) {
            filtered[i] *= 2;
            this.score += filtered[i];
            filtered[i + 1] = 0;
        }
        const merged = filtered.filter((value)=>value !== 0);
        while(merged.length < this.size)merged.push(0);
        return merged;
    }
    _moveLeft() {
        let moved = false;
        this.board = this.board.map((row)=>{
            const newRow = this._moveRowLeft(row);
            if (!this._areRowsEqual(row, newRow)) moved = true;
            return newRow;
        });
        if (moved) {
            this._addRandomTile();
            if (this._checkLose()) this.status = "lose";
            if (this._checkWin()) this.status = "win";
        }
    }
    _areRowsEqual(a, b) {
        return a.every((value, index)=>value === b[index]);
    }
    _reverseRows(board) {
        return board.map((row)=>[
                ...row
            ].reverse());
    }
    _transpose(board) {
        return board[0].map((_, col)=>board.map((row)=>row[col]));
    }
    _checkLose() {
        for(let row = 0; row < this.size; row++)for(let col = 0; col < this.size; col++){
            if (this.board[row][col] === 0) return false;
        }
        for(let row = 0; row < this.size; row++)for(let col = 0; col < this.size - 1; col++){
            if (this.board[row][col] === this.board[row][col + 1]) return false;
        }
        for(let col = 0; col < this.size; col++)for(let row = 0; row < this.size - 1; row++){
            if (this.board[row][col] === this.board[row + 1][col]) return false;
        }
        return true;
    }
    _checkWin() {
        for(let row = 0; row < this.size; row++)for(let col = 0; col < this.size; col++){
            if (this.board[row][col] === 2048) return true;
        }
        return false;
    }
    moveLeft() {
        this._moveLeft();
    }
    moveRight() {
        this.board = this._reverseRows(this.board);
        this._moveLeft();
        this.board = this._reverseRows(this.board);
    }
    moveUp() {
        this.board = this._transpose(this.board);
        this._moveLeft();
        this.board = this._transpose(this.board);
    }
    moveDown() {
        this.board = this._transpose(this.board);
        this.board = this._reverseRows(this.board);
        this._moveLeft();
        this.board = this._reverseRows(this.board);
        this.board = this._transpose(this.board);
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this._cloneBoard(this.board);
    }
    getStatus() {
        return this.status;
    }
    start() {
        if (this.status === "playing") return;
        this.score = 0;
        this.status = "playing";
        this.board = this._createEmptyBoard();
        this._addRandomTile();
        this._addRandomTile();
    }
    restart() {
        this.status = "idle";
        this.start();
    }
}


const $09e991522ca7e64e$var$game = new (0, $a5fd07fa01589658$export$2e2bcd8739ae039)();
const $09e991522ca7e64e$var$button = document.querySelector("button");
const $09e991522ca7e64e$var$cells = document.querySelectorAll(".field-cell");
const $09e991522ca7e64e$var$scoreEl = document.querySelector(".game-score");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
document.body.style.overflow = "hidden";
$09e991522ca7e64e$var$button.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "idle") {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$button.classList.replace("start", "restart");
        $09e991522ca7e64e$var$button.textContent = "Restart";
        $09e991522ca7e64e$var$messageStart.style.display = "none";
    } else {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$messageLose.classList.add("hidden");
        $09e991522ca7e64e$var$messageWin.classList.add("hidden");
    }
    $09e991522ca7e64e$var$renderBoard($09e991522ca7e64e$var$game.getState());
    $09e991522ca7e64e$var$updateScore($09e991522ca7e64e$var$game.getScore());
});
const $09e991522ca7e64e$var$keyActions = {
    ArrowLeft: ()=>$09e991522ca7e64e$var$game.moveLeft(),
    ArrowRight: ()=>$09e991522ca7e64e$var$game.moveRight(),
    ArrowUp: ()=>$09e991522ca7e64e$var$game.moveUp(),
    ArrowDown: ()=>$09e991522ca7e64e$var$game.moveDown()
};
document.addEventListener("keydown", (events)=>{
    const action = $09e991522ca7e64e$var$keyActions[events.key];
    if (!action) return;
    action();
    $09e991522ca7e64e$var$renderBoard($09e991522ca7e64e$var$game.getState());
    $09e991522ca7e64e$var$updateScore($09e991522ca7e64e$var$game.getScore());
    if ($09e991522ca7e64e$var$game.getStatus() === "lose") $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
    if ($09e991522ca7e64e$var$game.getStatus() === "win") $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
});
function $09e991522ca7e64e$var$renderBoard(board) {
    const flatBoard = board.flat();
    $09e991522ca7e64e$var$cells.forEach((cell, index)=>{
        const value = flatBoard[index];
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell";
        if (value > 0) cell.classList.add(`field-cell--${value}`);
    });
}
function $09e991522ca7e64e$var$updateScore(score) {
    $09e991522ca7e64e$var$scoreEl.textContent = score;
}


//# sourceMappingURL=index.4d229103.js.map
